export const CardBadge = {
  bindings: {
    icon: '@',
    text: '@',
  },

  template: `
    <div class="card-badge badge rounded bg-green text-teal-dark p-0">
      <i ng-if="$ctrl.icon" class="fa {{ $ctrl.icon }} text-teal-dark"></i>
      <span ng-if="$ctrl.text">{{ $ctrl.text }}</span>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Card/CardBadge.js